import { jsxs, jsx } from 'react/jsx-runtime';
import { LineIcon } from '../ui/icons/LineIcon.js';
import { useDevice } from '../../contexts/DeviceContext.js';
import { cn } from '../../lib/utils.js';
import { toast, Toaster as Toaster$1 } from 'sonner';

const ToastWrapper = ({
  children,
  hasClose,
  wide = false
}) => {
  const { isDesktop } = useDevice();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "min-h-9 rounded-[8px] bg-transparent-black-opacity-80 shadow-4 text-base-white py-3 px-4 flex items-start justify-between flex-nowrap gap-8 body-md mx-auto",
        wide ? isDesktop ? "w-[488px]" : "w-[290px]" : "inline-flex"
      ),
      children: [
        /* @__PURE__ */ jsx("div", { children }),
        hasClose && /* @__PURE__ */ jsx("div", { className: "pt-0.5 w-4 h-4 cursor-pointer", onClick: () => toast.dismiss(), children: /* @__PURE__ */ jsx(
          LineIcon,
          {
            icoColor: "bg-icon-base-white",
            icoName: "ico-close",
            type: "xs",
            className: "flex"
          }
        ) })
      ]
    }
  );
};
const ToastBox = ({
  title,
  desc,
  onClick
}) => {
  return /* @__PURE__ */ jsxs("dl", { className: "flex flex-col gap-1", onClick, children: [
    /* @__PURE__ */ jsx("dt", { className: "sc-font-family body-md text-base-white font-weight-regular text-left", children: title }),
    /* @__PURE__ */ jsx("dd", { className: "sc-font-family body-lg text-base-white font-weight-medium text-left", children: desc })
  ] });
};
const Toaster = ({ hasClose = false }) => {
  return /* @__PURE__ */ jsx(
    Toaster$1,
    {
      position: "bottom-center",
      closeButton: hasClose,
      className: "w-full min-h-[68px] flex justify-center z-[1000000] h-auto",
      style: { pointerEvents: "auto" }
    }
  );
};

export { ToastBox, ToastWrapper, Toaster };
